<template>
    <v-app class="view view--calendar" id="dayspan" v-cloak>
        <ds-calendar-app
                v-bind:calendar="calendar"
                v-on:actioned="handleAction"
                v-on:event-create="handleSubmit"
                v-on:event-remove="handleRemove"
                v-on:event-update="handleSubmit"
        ></ds-calendar-app>
        <task-list />
    </v-app>
</template>

<script>
    import { Calendar } from 'dayspan';
    import { eventBus } from '../../eventBus.js';
    import taskList from '../../components/TaskList.vue';

    export default {
        components: {
            taskList
        },
        data: function() {
            return {
                calendar: Calendar.months()
            }
        },
        methods: {
            getEvents: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/calendar/events', {
                    params : {
                        filters: {
                            'user_id': this.user.id
                        },
                        page: 1,
                        perPage: 0
                    }
                }).then(function (response) {
                    let events = response.body.original.data;

                    events.forEach(function(event) {
                        this.calendar.addEvent({
                            'data': {
                                'color': event.color,
                                'description': event.description,
                                'icon': event.icon,
                                'id': event.id,
                                'location': event.location,
                                'title': event.title
                            },
                            'schedule': JSON.parse(event.schedule)
                        })
                    }.bind(this));

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleAction: function (event) {
                if (event.type == 'cancel' || event.type == 'uncancel') {
                    let schedule = event.event.schedule.toInput();

                    schedule.cancel = event.event.schedule.cancel.map;

                    if (schedule.cancel.map) delete schedule.cancel.map;

                    this.$http.patch(this.apiUrl + '/calendar/events/' + event.event.data.id, {
                        'schedule': schedule,
                        'title': event.event.data.title
                    }).then(function (response) {
                        eventBus.$emit('hide-loader');
                        eventBus.$emit('show-alert', 'success', this.__('Event has been successfully canceled.'));
                    }.bind(this), function (response) {
                        if (response.status == 422 && response.body.errors) {
                            this.errors = response.body.errors;
                        }

                        eventBus.$emit('hide-loader');

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors validation the form. Please review and correct them.')
                        );
                    }.bind(this));
                }
            },
            handleRemove: function (event) {
                if (event.data.id) {
                    this.$http.delete(this.apiUrl + '/calendar/events/' + event.data.id).then(function (response) {
                        eventBus.$emit('hide-loader');
                        eventBus.$emit('show-alert', 'success', this.__('Event has been successfully removed.'));
                    }.bind(this), function (response) {
                        if (response.status == 422 && response.body.errors) {
                            this.errors = response.body.errors;
                        }

                        eventBus.$emit('hide-loader');

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors validation the form. Please review and correct them.')
                        );
                    }.bind(this));
                }
            },
            handleSubmit: function (event) {
                let data = {
                    'color': event.data.color,
                    'description': event.data.description,
                    'icon': event.data.icon,
                    'location': event.data.location,
                    'schedule': event.schedule.toInput(),
                    'title': event.data.title,
                    'user_id': this.user.id
                };
                const method = event.data.id ? 'patch' : 'post';
                const action = this.apiUrl + '/calendar/events' + (event.data.id ? ('/' + event.data.id) : '');


                eventBus.$emit('show-loader');

                this.$http[method](action, data).then(function (response) {
                    this.calendar.events[this.calendar.events.length - 1].data.id = response.body.id;
                    eventBus.$emit('hide-loader');
                    eventBus.$emit('show-alert', 'success', this.__('Event has been successfully saved.'));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            },
            init: function () {
                this.getEvents();
            }
        },
        mounted: function () {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/calendar/Index.vue